import { Box, Card, Link, Stack, Typography, styled } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const FooterWrapper = styled(Card)(
  ({ theme }) => `
        border-radius: 0;
        margin-top: ${theme.spacing(3)};
`
);

function Footer() {
  return (
    <FooterWrapper className="footer-wrapper">
      <Box
        p={{ xs: 2.5, md: 3 }}
        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="subtitle1">
            2025 © AutoClever. All rights reserved.
          </Typography>
        </Box>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          sx={{
            pt: { xs: 2, md: 0 }
          }}
        >
          <Link component={RouterLink} to="/support" color="inherit">
            Support
          </Link>
          <Link component={RouterLink} to="/privacy" color="inherit">
            Privacy
          </Link>
          <Link component={RouterLink} to="/terms" color="inherit">
            Terms
          </Link>
          <Link component={RouterLink} to="/account-deletion" color="inherit">
            Account deletion
          </Link>
        </Stack>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
